import { styled, Toolbar } from '@mui/material';
import { type ReactNode } from 'react';
import { IncidentBanner } from '../Common/IncidentBanner';
import { AccountDashboardAppBar } from './AccountDashboardBar';

export const DASHBOARD_LAYOUT_GAP = 64;
export const DASHBOARD_LAYOUT_GAP_PX = `${DASHBOARD_LAYOUT_GAP}px`;

const AccountDashboardContent = styled('div')`
  display: flex;
  flex: 1 1 auto;
  max-width: 100%;
  padding-top: ${DASHBOARD_LAYOUT_GAP_PX};
  min-height: 100vh;
`;

const AccountDashboardBody = styled('div')`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
`;

export const AccountDashboardOutline = ({ children }: { children?: ReactNode }) => (
  <AccountDashboardContent>
    <AccountDashboardBody>{children}</AccountDashboardBody>
    <AccountDashboardAppBar sx={{ pl: { lg: 0 } }}>
      <Toolbar>
        <IncidentBanner />
      </Toolbar>
    </AccountDashboardAppBar>
  </AccountDashboardContent>
);
